import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_DOCUMENT + name;
};

export let PathnameDocument = {
  LANDING_PAGE: "/",
  PRIVATE: "/private",
  SHARED: "/shared",
  PUBLIC: "/public",
  SETTING: "/setting",
  FORMS: "/setting/forms",
  ADD_CUSTOM_FIELDS: "/setting/forms/add-custom-fields",
};
